import React from 'react';
import { useT } from '@/lib/i18n';
import { LegalLayout } from '@/components/legal/LegalLayout';

const Privacy = () => {
  const { lang } = useT();
  const fr = (
    <>
      <h2>1. Responsable du traitement</h2>
      <p>Le responsable du traitement des données personnelles est <strong>[À COMPLÉTER — raison sociale]</strong>. Contact DPO : <a href="mailto:contact@highlightai.online">contact@highlightai.online</a></p>

      <h2>2. Données collectées</h2>
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li><strong>Données de compte</strong> : email, nom, mot de passe haché (bcrypt), avatar Google si OAuth</li>
        <li><strong>Données de facturation</strong> : traitées exclusivement par Stripe — HighlightAI ne stocke aucune donnée bancaire</li>
        <li><strong>Vidéos uploadées et clips générés</strong> : stockés sur infrastructure sécurisée UE, accessibles uniquement par votre compte</li>
        <li><strong>Données techniques</strong> : adresse IP, user-agent, logs de connexion (conservés 12 mois)</li>
        <li><strong>Cookies YouTube</strong> (optionnels, Pro) : stockés chiffrés base64 dans votre profil, supprimables à tout moment</li>
      </ul>

      <h2>3. Finalités</h2>
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li>Fournir le service (génération de clips, hébergement)</li>
        <li>Facturation et gestion des abonnements</li>
        <li>Sécurité et prévention de la fraude</li>
        <li>Communication transactionnelle (emails de notification)</li>
      </ul>

      <h2>4. Base légale</h2>
      <p>Exécution du contrat (art. 6.1.b RGPD) pour le service et la facturation. Intérêt légitime (art. 6.1.f) pour la sécurité et l&apos;amélioration du service.</p>

      <h2>5. Sous-traitants</h2>
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li><strong>Stripe</strong> (paiements) — États-Unis, transfert encadré par les Clauses Contractuelles Types</li>
        <li><strong>OpenAI</strong> (Whisper transcription + GPT analyse) — données vidéo traitées sans rétention selon politique OpenAI</li>
        <li><strong>Resend</strong> (emails transactionnels) — États-Unis</li>
        <li><strong>Emergent</strong> (hébergement Kubernetes + Object Storage) — Union européenne</li>
      </ul>

      <h2>6. Durée de conservation</h2>
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li>Compte actif : durée de l&apos;abonnement + 3 ans après dernière activité</li>
        <li>Vidéos/clips : durée de l&apos;abonnement, supprimés sous 30 jours après résiliation</li>
        <li>Factures : 10 ans (obligation légale française)</li>
      </ul>

      <h2>7. Vos droits RGPD</h2>
      <p>Conformément aux articles 15 à 22 du RGPD, vous disposez d&apos;un droit d&apos;accès, de rectification, d&apos;effacement, de limitation, de portabilité et d&apos;opposition. Pour exercer ces droits : <a href="mailto:contact@highlightai.online">contact@highlightai.online</a></p>
      <p>Vous pouvez également déposer une plainte auprès de la <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">CNIL</a>.</p>

      <h2>8. Sécurité</h2>
      <p>Mots de passe hachés (bcrypt), connexion TLS 1.3, isolation par utilisateur, sauvegardes chiffrées. Audit de sécurité annuel.</p>
    </>
  );
  const en = (
    <>
      <h2>1. Controller</h2>
      <p>The data controller is <strong>[TO COMPLETE]</strong>. DPO contact: <a href="mailto:contact@highlightai.online">contact@highlightai.online</a></p>
      <h2>2. Data collected</h2>
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li>Account: email, name, bcrypt-hashed password, Google avatar if OAuth</li>
        <li>Billing: handled exclusively by Stripe — no card data stored</li>
        <li>Videos & clips: stored on secure EU infrastructure, accessible only by your account</li>
        <li>Technical: IP, user-agent, login logs (12 months retention)</li>
        <li>YouTube cookies (optional, Pro): stored base64-encoded in your profile, deletable anytime</li>
      </ul>
      <h2>3. Purposes</h2>
      <p>Service delivery, billing, fraud prevention, transactional emails.</p>
      <h2>4. Legal basis</h2>
      <p>Contract performance (GDPR art. 6.1.b) and legitimate interest (art. 6.1.f) for security.</p>
      <h2>5. Processors</h2>
      <p><strong>Stripe</strong> (payments, USA, SCC), <strong>OpenAI</strong> (Whisper + GPT, no retention policy), <strong>Resend</strong> (emails, USA), <strong>Emergent</strong> (hosting, EU).</p>
      <h2>6. Retention</h2>
      <p>Account: subscription duration + 3 years. Videos: subscription duration, deleted within 30 days after cancellation. Invoices: 10 years (French legal requirement).</p>
      <h2>7. Your rights (GDPR)</h2>
      <p>Access, rectification, erasure, restriction, portability, objection (GDPR art. 15-22). Contact: <a href="mailto:contact@highlightai.online">contact@highlightai.online</a>. You may also file a complaint with the <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">CNIL</a>.</p>
      <h2>8. Security</h2>
      <p>Bcrypt-hashed passwords, TLS 1.3, per-user isolation, encrypted backups. Annual security audit.</p>
    </>
  );
  return <LegalLayout titleFr="Politique de confidentialité" titleEn="Privacy Policy">{lang === 'fr' ? fr : en}</LegalLayout>;
};

export default Privacy;
